import React from "react";
import SupportForm from "./supportForm";

const SupportSection = () => {
  return (
    <div>
      <SupportForm />
    </div>
  );
};

export default SupportSection;
